import { GlobalProps } from "@emotion/react";

import { Theme, ThemeOptions } from "@mui/material";

export const themeOptions: ThemeOptions = {
    palette: {
        error: {
            main: "#AA1E00",
        },
    },
    breakpoints: {
        values: {
            xs: 0,
            sm: 600,
            md: 900,
            lg: 1200,
            xl: 1536,

            // TODO: Avoid using these breakpoints. They will be removed in the next major version of the Shared Packages CFC-000
            mobile: 0,
            tablet: 0,
            laptop: 0,
            desktop: 0,
        },
    },
    components: {
        MuiTextField: {
            defaultProps: {
                fullWidth: true,
                size: "small",
            },
        },
        MuiCard: {
            styleOverrides: {
                root: {
                    borderRadius: "8px",
                },
            },
        },
        MuiCardHeader: {
            styleOverrides: {
                root: {
                    padding: "24px 24px 0px 24px",
                },
            },
        },
        MuiCardContent: {
            styleOverrides: {
                root: {
                    padding: "16px 24px 24px 24px",
                },
            },
        },
    },
};

export const getGlobalStyles = (theme: Theme): GlobalProps["styles"] => ({
    a: { color: theme.palette.primary.main },
    main: {
        paddingTop: "16px",
        maxWidth: "1516px",
        width: "100%",
        marginLeft: "auto",
        marginRight: "auto",
    },
});
